export function computeExpansionState(id: string, openIds: Set<string>, parentIds: string[]) {
  const isParentExpanded =
    parentIds.every((parentId) => openIds.has(parentId)) || parentIds.length === 0;
  const isExpanded = openIds.has(id);

  return {
    isParentExpanded,
    isExpanded,
  };
}

export function getChildrenQuestionCount({
  id,
  rows,
  chapterQuestionDistribution,
}: {
  id: string;
  rows: {
    id: string;
    parentIds?: string[];
  }[];
  chapterQuestionDistribution: Record<string, number> | null;
}) {
  const hasChildren = rows.some((child) => child.parentIds?.includes(id));

  if (!hasChildren) {
    return {
      childrenQuestionCount: 0,
    };
  }

  const childrenQuestionCount = Object.keys(chapterQuestionDistribution || {}).reduce(
    (acc, curr) => {
      const childRow = rows.find((r) => r.id === curr);

      if (childRow?.parentIds?.includes(id)) {
        const questionCount = chapterQuestionDistribution?.[curr] || 0;
        return acc + questionCount;
      }

      return acc;
    },
    0,
  );

  return {
    childrenQuestionCount,
  };
}
